import { useMergeRefs } from "@floating-ui/react";
import { useLayoutEffect, useRef } from "react";

import { TextArea } from "@smart/itops-sb-design-system-dom";

import { FieldGroup } from "./field-group";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";

export const MultilineField = ({
  field,
  index,
  innerRef,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
}: FieldProps<HTMLTextAreaElement>) => {
  const fieldRef = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    if (fieldRef?.current) {
      fieldRef.current.style.height = "0";
      fieldRef.current.style.height = `${fieldRef.current.scrollHeight + 4}px`;
    }
  }, [value]);
  const id = fieldName({ field, index });
  const mergedRef = useMergeRefs([innerRef, fieldRef]);
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
      >
        <TextArea
          className="[&>textarea]:min-h-[8rem] text-mobile mobile:text-ui"
          ref={mergedRef}
          id={id}
          name={id}
          data-testid={id}
          error={!!error}
          message={error ?? undefined}
          aria-invalid={!!error}
          aria-errormessage={errorId ?? undefined}
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
        />
      </FieldGroup>
    </FieldWrapper>
  );
};
